import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Button, styled, Typography } from '@mui/material';

import { FC } from 'react';

type FileSelectAreaProps = {
  'data-testid'?: string;
  disabled?: boolean;
  errorMessage?: string;
  filename?: string;
};

const SelectArea = styled('div')<FileSelectAreaProps>(props => ({
  '&:hover': props.disabled
    ? undefined
    : {
        borderColor: props.theme.palette.primary.dark,
        cursor: 'pointer'
      },
  '&:hover .MuiButton-root:not(:disabled)': {
    backgroundColor: props.theme.palette.primary.dark
  },
  alignItems: 'center',
  border: `1px solid ${props.theme.palette.grey[300]}`,
  borderRadius: props.theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  gap: props.theme.spacing(1),
  justifyContent: 'center',
  padding: props.theme.spacing(5)
}));

export const FileSelectArea: FC<FileSelectAreaProps> = props => {
  const { 'data-testid': testId = 'file-select-area' } = props;

  return (
    <SelectArea data-testid={testId} disabled={props.disabled}>
      <Button
        disabled={props.disabled}
        startIcon={<FileUploadOutlinedIcon />}
        variant='contained'>
        Select File
      </Button>
      <Typography color={props.errorMessage ? 'error.main' : 'text.secondary'}>
        {props.errorMessage || props.filename || 'No file chosen'}
      </Typography>
    </SelectArea>
  );
};
